export const UPDATE_USER_SUBJECTS = "updateUserSubjects";
export const RESET_STORE = "resetStore";
